import { redirect } from "react-router-dom";
import { COMPLAINT_CASE_POST_API, 
         COMPLAINT_CASE_NOTES_PATCH_API, 
         COMPLAINT_CASE_DELETE_API,
         COMPLAINT_CASE_FORM_LINK_GET_API,
         COMPLAINT_CASE_FINISH_PATCH_API } from '../../constants/apis';
import { COMPLAINT_CASE_LIST_PATH, LOGIN_PATH } from '../../constants/paths';
import { getModel, postModel, patchModel, deleteModel } from '../../utils/functions';
import { DEFAULT_UNKNOWN_ERROR_MESSAGE } from '../../constants/constants';


export async function complaintCaseAction({ params, request }) {
    const requestData = await request.json();

    let data;

    if (requestData !== null) {
        if (requestData.resetWarnings) {        
            return {
                message: "",
                parameters: []
            };
        }
        if (requestData.copyFormLink) {
            const recoveryPath = await getModel(COMPLAINT_CASE_FORM_LINK_GET_API.replace('{id}', params.complaint_case_id));

            const fullPath = `${window.location.protocol}//${window.location.host}${recoveryPath}`;

            const permissionStatus = await navigator.permissions.query({name: 'clipboard-write'});

            let formLinkCopied = false;

            if(permissionStatus.state === 'granted') {
                await navigator.clipboard.writeText(fullPath);
                formLinkCopied = true;
            }
            else {
                window.open(fullPath, '_blank');
            }

            return {
                formLinkCopied,
                message: "",
                parameters: []
            };
        }
        if (requestData.archiveComplaintCase) {
            await patchModel(COMPLAINT_CASE_FINISH_PATCH_API.replace('{id}', params.complaint_case_id), {has_finished: requestData.has_finished});

            return {
                complaintCaseHasFinished: requestData.has_finished,
                message: "",
                parameters: []
            };
        }
    
        data = requestData.data;
    }    

    try {
        switch (request.method) {
            case "POST":
                await postModel(COMPLAINT_CASE_POST_API, data);

                return redirect(COMPLAINT_CASE_LIST_PATH);
            case "PATCH":
                await patchModel(COMPLAINT_CASE_NOTES_PATCH_API.replace('{id}', params.complaint_case_id), data);

                return redirect(COMPLAINT_CASE_LIST_PATH);
            case "DELETE":
                await deleteModel(`${COMPLAINT_CASE_DELETE_API}${params.complaint_case_id}`);
                
                return redirect(COMPLAINT_CASE_LIST_PATH);
            default:
                return {
                    message: "Esta página possui erros de implementação/desenvolvimento.",
                    parameters: []
                };
        }
    }
    catch(errors) {
        let message = [];
        let parameters = [];

        if(errors instanceof Array) {
            for(let error of errors) {
                if(error.code === 103) {
                    for(let parameter of error.parameters) {
                        if(parameter.name === 'name') {
                            message.push('Nome já cadastrado');
                            parameters.push('name');
                        }
                    }
                }
                else if(error.code === 208) {
                    if(error.message.includes('id might be invalid')) {
                        message.push('Caso não encontrado');
                    }
                }
                else if(error.code === 209) {
                    // message.push('Sessão do usuário expirada');
                    return redirect(LOGIN_PATH);
                }
            }
        }

        if (message.length <= 0) {
            message = [DEFAULT_UNKNOWN_ERROR_MESSAGE];
        }
    
        return {
            parameters,
            message: `${message.join('; ')}.`
        };
    }
  };